import APIClient from '../../../common/APIClient';
import { toggleShowAlert, displayError, SUCCESS_ALERT, MAX_ITEMS_IN_PAGE, setIsSaving } from '../commonActions';
import qs from 'qs';
import { DRAFT } from '../posts/postsActions'

const FETCH_MOBILE_APP_BANNERS = 'FETCH_MOBILE_APP_BANNERS';
const SET_MOBILE_APP_BANNER_FIELD_CHANGE = 'SET_MOBILE_APP_BANNER_FIELD_CHANGE';
const SET_MOBILE_APP_BANNER = 'SET_MOBILE_APP_BANNER';
const RESET_MOBILE_APP_BANNER = 'RESET_MOBILE_APP_BANNER';
const MOBILE_APP_BANNER_FILTER = 'MOBILE_APP_BANNER_FILTER';

export const SET_MOBILE_APP_BANNERS_PAGINATION = 'SET_MOBILE_APP_BANNERS_PAGINATION';
export const RESET_MOBILE_APP_BANNERS_PAGINATION = 'RESET_MOBILE_APP_BANNERS_PAGINATION';

const client = () => {
    var apiClient = new APIClient();
    return apiClient.make();
}
export const fetchMobileAppBanners = (filters = null, page = 1, limit = MAX_ITEMS_IN_PAGE) => {
    return (dispatch, getState) => {

        page = getState().mobileappbanners.currentPage;

        client().get(
            'banner/list', {
            params: {
                filters,
                page,
                limit
            },
            paramsSerializer: params => {
                return qs.stringify(params)
            },
        }
        ).then(json => {
            const result = json.data;
            
            if (result) {
                let mobileappbanners = result.data;
                if (!mobileappbanners.length) {
                    mobileappbanners = null;
                }
                else {
                    
                    let numItems = result.pagination.total_items;
                    let min = getState().mobileappbanners.min;
                    let max = numItems < MAX_ITEMS_IN_PAGE ? numItems : getState().mobileappbanners.max;
                    
                    const totalPages = Math.ceil(numItems / MAX_ITEMS_IN_PAGE);

                    dispatch({ type: SET_MOBILE_APP_BANNERS_PAGINATION, numItems, min, max, totalPages });
                }
                dispatch({ type: FETCH_MOBILE_APP_BANNERS, mobileappbanners });
                
            }

        }).catch(error => {
            dispatch(displayError(error))
        })
    }
}

export const handleInputChange = (e, definedValue = null) => {
    return (dispatch) => {
        let value = {}
        if (!e && definedValue) {
            value = definedValue;
        }
        
        else {
            const id = e.target.id;

            value = {
                [id]: e.target.value
            }
        }
        dispatch({ type: SET_MOBILE_APP_BANNER_FIELD_CHANGE, value })
    }
}

export const getMobileAppBanner = (id) => {
  return (dispatch) => {
    dispatch(resetMobileAppBanner());

    client()
      .get('banner/get', {
        params: {
          id
        }
      })
      .then(json => {
        const result = json.data;
        if (result) {
            let mobileappbanner = result.data;
          dispatch({ type: SET_MOBILE_APP_BANNER, mobileappbanner });
        }
      })
      .catch(error => {
        dispatch(displayError(error));
      });
  };
};


export const upsertMobileAppBanner = (callback = null) => {
    return (dispatch, getState) => {
        dispatch(setIsSaving(true));
        
        const clientObj = getState().mobileappbanners.mobileappbanner;
        clientObj.external_url = clientObj.external_url || "";
        clientObj.status = clientObj?.status || DRAFT;
        clientObj.image_url = clientObj?.image_url || '';
        delete clientObj.updated_at;
        delete clientObj.updated_by;
        delete clientObj.created_at;
        delete clientObj.created_by;
        
        let endpoint = 'banner/create';
        let message = 'Mobile App Banner has been successfully created.';

        if (clientObj.id) {
            endpoint = 'banner/update';
            message = 'Mobile App Banner has been successfully updated.';
        }

        client().post(
            endpoint,
            clientObj
        ).then(json => {
            const result = json.data;
            if (result) {
                dispatch(toggleShowAlert(true, SUCCESS_ALERT, message));
                if (!clientObj.id) {
                    const value = { id: result.data }
                    dispatch({ type: SET_MOBILE_APP_BANNER_FIELD_CHANGE, value })
                }
            }
        }).finally(() => {
            dispatch(setIsSaving(false));
            window.location.replace('/#/mobile-app-banner')
        })
            .catch(error => {
                dispatch(displayError(error))
            })
    }
}

export const resetMobileAppBanner = () => {
    return (dispatch) => {
        dispatch({ type: RESET_MOBILE_APP_BANNER });
    }
}

export const filterMobileAppBanners = (filter) => {
    return (dispatch) => {
        dispatch({ type: MOBILE_APP_BANNER_FILTER, filter });
    }
}